export const gitCommit = '9018fcb1'
